import { render, staticRenderFns } from "./CityPartners.vue?vue&type=template&id=4316bfbc"
import script from "./CityPartners.vue?vue&type=script&lang=js"
export * from "./CityPartners.vue?vue&type=script&lang=js"
import style0 from "./CityPartners.vue?vue&type=style&index=0&id=4316bfbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports